/* Below-the-fold videos load only when scrolled near (home page). Each <video class="tt-lazyvid">
   carries data-src and a poster; nothing downloads until it is within 400px of the viewport.
   iPhones (Josh, 2026-10-17: the Player Desk video never played on mobile): Safari pauses a muted
   video that is off screen, and one started without the autoplay flag is never resumed. So each
   video is flagged autoplay + muted before it gets its source, and is played again every time it
   comes into view. Low Power Mode still blocks autoplay; the poster shows then. */
(function () {
  var vids = document.querySelectorAll('video.tt-lazyvid[data-src]');
  if (!vids.length) return;
  /* When iOS refuses to start a video by itself (Low Power Mode, data saver) it shows a play
     button instead (Josh, 2026-10-17: "I don't want play buttons. I just want them to play").
     Safari plays an MP4 named as an <img> src like an animated image, muted and looping, and
     does not hold it back, so a refused video is swapped for one. Other browsers never refuse a
     muted inline video, and keep the <video>. */
  function asImage(v) {
    var src = v.currentSrc || v.src;
    if (!src || !v.parentNode) return;
    var img = document.createElement('img');
    img.className = v.className + ' tt-lazyvid--img';
    img.setAttribute('style', v.getAttribute('style') || '');
    img.alt = '';
    img.setAttribute('aria-hidden', 'true');
    img.onerror = function () { if (img.parentNode) img.parentNode.replaceChild(v, img); };
    img.src = src;
    v.parentNode.replaceChild(img, v);
  }
  function play(v) {
    var p = v.play();
    if (p && p.catch) p.catch(function (e) { if (e && e.name === 'NotAllowedError') asImage(v); });
  }
  function load(v) {
    v.muted = true;
    v.defaultMuted = true;
    v.autoplay = true;
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');
    v.setAttribute('autoplay', '');
    v.src = v.getAttribute('data-src');
    v.removeAttribute('data-src');
    play(v);
  }
  if (!('IntersectionObserver' in window)) { vids.forEach(load); return; }
  var near = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      near.unobserve(e.target);
      load(e.target);
    });
  }, { rootMargin: '400px 0px' });
  var seen = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting && e.target.paused && !e.target.hasAttribute('data-src')) play(e.target);
    });
  }, { threshold: 0.25 });
  vids.forEach(function (v) { near.observe(v); seen.observe(v); });
})();
